import { useEffect, useState } from 'react';

/**
 * Returns true when the viewport matches the `lg` Tailwind breakpoint
 * (>= 1024px). Used by the layouts so we only stamp `data-walkthrough`
 * attributes onto the layout that is actually visible — otherwise both
 * the desktop sidebar and the mobile bottom nav both carry the same
 * data-walkthrough attribute and Joyride's querySelector picks the
 * hidden (0x0) one first.
 */
export function useIsLargeScreen() {
  const getMatch = () =>
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(min-width: 1024px)').matches;

  const [isLarge, setIsLarge] = useState(getMatch);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia('(min-width: 1024px)');
    const onChange = (e) => setIsLarge(e.matches);
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);
    // Sync once on mount in case the initial value drifted.
    setIsLarge(mq.matches);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', onChange);
      else mq.removeListener(onChange);
    };
  }, []);

  return isLarge;
}
